import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { detectIE, dataLayerEvents } from 'common/utils';
import { Responsive } from 'common/components';
import Icon from '../Icon';

import * as css from './AccessibilityIcon.scss';

class AccessibilityIcon extends Component {
	static propTypes = {
		// eslint-disable-next-line react/require-default-props
		onClick: PropTypes.func,
	};

	// eslint-disable-next-line class-methods-use-this
	get accessablityBtn() {
		return document.querySelector('#INDmenu-btn');
	}

	onClick = event => {
		this.accessablityBtn.click();
		this.props.onClick(event);
		dataLayerEvents.onAccessibilityClick();
	};

	onMouseEnter = () => {
		let eventFocus;
		if (Responsive.isMatching(Responsive.DESKTOP)) {
			if (detectIE() > 0) {
				eventFocus = document.createEvent('Event');
				eventFocus.initEvent('focus', false, true);
			} else {
				eventFocus = new Event('focus');
			}
			this.accessablityBtn.dispatchEvent(eventFocus);
		}
	};

	onMouseLeave = () => {
		let eventBlur;

		if (detectIE() > 0) {
			eventBlur = document.createEvent('Event');
			eventBlur.initEvent('blur', false, true);
		} else {
			eventBlur = new Event('blur');
		}

		this.accessablityBtn.dispatchEvent(eventBlur);
	};

	render() {
		return (
			<button
				type="button"
				onClick={this.onClick}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
				className={css.button}
			>
				<Icon type={Icon.ACCESSABILITY} />
			</button>
		);
	}
}

export default AccessibilityIcon;
